export class AuthError extends Error {
    code: string;
    extra: any;

    constructor(code: string, msg?: string, extra?: any) {
        super(msg || 'Internt fel A1');
        this.code = code;
        this.extra = extra;
    }
}
